module.exports = __webpack_public_path__ + "img/jsicon.465262f1.png";